import Tool, { type ToolArgsWithController } from '../../../tools/Tool';
import { svgToIcon } from '../../../components/Toolbar/toolbarUtils';
import wordCountSvg from '../../../assets/icons/wordCount.svg';
import {
  WORD_COUNT_PLUGIN_ID,
  type WordCountPluginType,
} from '../WordCountPlugin';

class ToolWordCount extends Tool {
  static toolName = 'Word count';

  static action({ controller }: ToolArgsWithController) {
    const wordCountPlugin = controller.ahaEditor.getPlugin(
      WORD_COUNT_PLUGIN_ID
    ) as WordCountPluginType;

    wordCountPlugin?.api.openModal();
  }

  static renderToolbarButtonIcon() {
    return svgToIcon(wordCountSvg);
  }

  static tooltip() {
    return '';
  }

  static renderMenuIcon() {
    return svgToIcon(wordCountSvg);
  }
}

export default ToolWordCount;
